import { Component, Input, OnInit } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { HYST_ADJUSTMENT_WHEN_NO_VALUE_AVAILABLE } from 'src/environments/environment';

type RoomTempData = { baseSetProp: Property; ecoHyst1Prop: Property; ecoHyst2Prop: Property; regulationProp?: Property };

@Component({
  selector: 'app-room-temp-info',
  templateUrl: './room-temp-info.component.html',
  styleUrls: ['./room-temp-info.component.scss']
})
export class RoomTempInfoComponent implements OnInit {
  Property = Property;
  @Input() selectedControllers: Controller[];
  @Input() location: 'room' | 'bathroom';
  @Input({required: true}) areaName: string;

  updated$ = this.projectService.updatedPipe$;
  hystConfig = HYST_ADJUSTMENT_WHEN_NO_VALUE_AVAILABLE;

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {}

  get hyst1Fallback(): number {
    return this.location === 'room' ? (this.hystConfig?.roomHyst1 ?? 0) : (this.hystConfig?.bathroomHyst1 ?? 0);
  }

  get hyst2Fallback(): number {
    return this.location === 'room' ? (this.hystConfig?.roomHyst2 ?? 0) : (this.hystConfig?.bathroomHyst2 ?? 0);
  }

  getBaseSetPropValue(data: RoomTempData): number {
    return +data?.baseSetProp?.value || 0;
  }

  getHyst1(data: RoomTempData): number {
    return +data?.ecoHyst1Prop?.value || this.hyst1Fallback;
  }

  getHyst2(data: RoomTempData): number {
    return +data?.ecoHyst2Prop?.value || this.hyst2Fallback;
  }

  getRegulationPropValue(data: RoomTempData): number {
    return +data?.regulationProp?.value || 0;
  }

  isAutoActive(hvacHCAutoProps: Property[]): boolean {
    return hvacHCAutoProps.length > 0 && hvacHCAutoProps[0]?.value?.toString() === '1';
  }
}
